import ImageContainer from '../components/ImageContainer'
import Layout from '../components/Layout'
// import PropTypes from 'prop-types'
import React from 'react'
import TwoColImageText from '../components/TwoColImageText'

const Content = ({ index, title, description }) => (
  <div className="has-text-centered">
    <h1 className="title is-marginless brand-color">{index}</h1>
    <h3 className="is-size-4 border-b-c brown-border brand-color">{title}</h3>
    <p className="is-size-6">{description}</p>
  </div>
)

export default class AboutPage extends React.Component {
  render() {
    return (
      <Layout>
        <ImageContainer imageUrl="/img/about_us/banner.jpg">
          <div className="half-w main-banner-pd has-text-white">
            <h1 class="is-big-font has-text-white border-b-l white-btm long-btm mb-space">
              More Than Coffee at Freedom Depot
            </h1>
            <h4>
              Caffe Bene is pursuing an aromatic coffee culture, diversified
              desserts and a relaxing space to stimulate creativity
            </h4>
          </div>
        </ImageContainer>
        <div className="section">
          <div className="container">
            <div className="has-text-centered mg-btm-2">
              <h1 className="title brand-color">Caffe Bene Philosophy</h1>
              <p className="is-size-5">
                Caffe Bene is aiming at delicious coffee, diversified desserts
                and fragrant culture.
              </p>
            </div>

            <TwoColImageText imageUrl="/img/about_us/roasting_principle.jpg">
              <Content
                index="01"
                title="Roasting principle"
                description="Rich aroma and flavor of each raw coffee bean are delivering through Caffe Bene’s method, blending after pre-roasting.
"
              />
            </TwoColImageText>

            <TwoColImageText
              textLeft={true}
              imageUrl="/img/about_us/more_than_coffee.jpg"
            >
              <Content
                index="02"
                title="More Than Coffee"
                description="Caffe Bene is pursuing a culture with a cup of fresh coffee, complement with a variety of desserts, experience a relax and creative space that stimulates creativity, and creates a moment you will share with good friends. "
              />
            </TwoColImageText>
          </div>
        </div>
      </Layout>
    )
  }
}
